module.exports = __webpack_public_path__ + "static/img/title.d1b6c50.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/feature/title.png
// module id = ozNp
// module chunks = 7